export const menuOptionsTime = {
  1: "This year",
  2: "Last 2 years",
  3: "Last 3 years",
  5: "Last 5 years",
  10: "Last 10 years"
};
